import React from 'react';

import { GridActionsCellItem, GridColDef, GridRowId, GridRowParams } from '@mui/x-data-grid';
import { Button, Grid, Stack, Typography, Box, Checkbox, Paper, FormControl } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

import * as Api from 'api';

import * as CardsApi from 'api/cards';

import ErrorMessage from 'tsui/ErrorMessage';
import CardDetailsModal from './Cards/CardDetailsModal';
import ProduceCardsModal from '../../pages/admin/cards/ProduceCardsModal';
import IssuedCard from '../../pages/admin/cards/ActivatedCard';

import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import DirectionsIcon from '@mui/icons-material/Directions';
import BackspaceIcon from '@mui/icons-material/Backspace';

import { debounce } from '@mui/material/utils';
import {
    DataGridPro,
    GridFetchRowsParams,
    useGridApiRef,
} from '@mui/x-data-grid-pro';


export class CardRowDisplayData {
    cardId: string;

    userId?: string;

    guiCardDate: Date | undefined; //TODO DATE

    printed: string | boolean;
    issued: string | boolean;
    activated: string | boolean;

    cardType: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    profession?: string;
    location?: string;
    phoneNumber?: string;
    workingTime?: string;
    locationIcon?: string;
    facebook?: string;
    instagram?: string;
    linkedIn?: string;
    template?: string;
    profileImage?: string;

    userInfo?: string;

    constructor(c: CardsApi.ApiCard) {
        this.cardId = c.cardId;
        this.template = c.template;
        this.cardType = c.cardType;
        this.printed = c.printed;
        this.issued = c.issued;
        this.activated = c.activated;
        this.userId = c.userId;

        if (c.userData) {
            let ud = c.userData!;
            this.userInfo = `${ud.userId} - ${ud.email}`;
            //console.log('this.userInfo', this.userInfo)
        }
    }
}

export default function CardsTab() {
    const mounted = React.useRef(false);
    const [dataRequested, setDataRequested] = React.useState(false);
    let [error, setError] = React.useState<Error | null>(null);
    const [cards, setCards] = React.useState<CardRowDisplayData[] | null>(null);
    let [cardDetailsId, setCardDetailsId] = React.useState<string | null>(null);
    let [produceCards, setPrdouceCards] = React.useState(false);
    let [issuedCard, setIssuedCard] = React.useState<string | null>(null);

    const [issuedStatus, setIssuedStatus] = React.useState(false);
    const [issuedStatusString, setIssuedStatusString] = React.useState('false');

    const [printedStatus, setPrintedStatus] = React.useState(false);
    const [printedStatusString, setPrintedStatusString] = React.useState('false');

    const [vipStatus, setVipStatus] = React.useState(false);
    const [vipStatusString, setVipStatusString] = React.useState('false');

    const [activatedStatus, setActivatedStatus] = React.useState(false);
    const [activatedStatusString, setActivatedStatusString] = React.useState('false');

    const [searchVal, setSearchVal] = React.useState('');



    const apiRef = useGridApiRef();
    const [rowCount, setRowCount] = React.useState(0);


    // const issuedStatusRef = React.useRef(false)






    React.useEffect(() => {

        mounted.current = true;
        if (!dataRequested) {
            // Api.requestAdmin<CardsApi.ApiCard[]>('cards', 'fetch_data_grid_pro', { firstRowToRender: '0', lastRowToRender: '5' }).then(messages => {
            Api.requestAdmin<any>('cards', 'fetch_data_grid_pro', { firstRowToRender: '0', lastRowToRender: '10', vipStatus: vipStatusString, issuedStatus: issuedStatusString, printedStatus: printedStatusString, activatedStatus: activatedStatusString, searchVal: searchVal === '' ? 'empty' : searchVal }).then(d => {
                if (mounted.current) {
                    let cardsData: CardRowDisplayData[] = [];

                    if (d.cardsData) {
                        for (let c of d.cardsData) {
                            cardsData.push(new CardRowDisplayData(c));
                        }
                        setCards(cardsData)
                    }
                    if (d.cardsCount) {
                        setRowCount(d.cardsCount)
                    }

                }

            }).catch(alert);
            setDataRequested(true);
            return;
        }
        return () => {
            mounted.current = false;
        };
    }, [dataRequested]);


    const handleFetchRows = React.useCallback(
        async (params: GridFetchRowsParams) => {
            let d = await Api.requestAdmin<any>('cards', 'fetch_data_grid_pro', 
                { firstRowToRender: params.firstRowToRender.toString(), 
                    lastRowToRender: params.lastRowToRender.toString(), 
                    vipStatus: vipStatusString, 
                    issuedStatus: issuedStatusString, 
                    printedStatus: printedStatusString, 
                    activatedStatus: activatedStatusString, 
                    searchVal: searchVal === '' ? 'empty' : searchVal 
                });
            let cardsData: CardRowDisplayData[] = [];

            for (let c of d.cardsData) {
                cardsData.push(new CardRowDisplayData(c));
            }

            apiRef.current.unstable_replaceRows(params.firstRowToRender, cardsData);
        },
        [apiRef, vipStatusString, printedStatusString],
    );

    const debouncedHandleFetchRows = React.useMemo(
        () => debounce(handleFetchRows, 200), [handleFetchRows],
    );


    ///////////////////////////////////////////////////////////



    const gridColumns = React.useMemo<GridColDef[]>(
        () => [
            // { field: 'template', headerName: 'template Version', headerAlign: 'center', width: 80 },
            { field: 'cardId', headerName: 'Card Id', headerAlign: 'center', width: 80 },
            { field: 'cardType', headerName: 'Card Type', headerAlign: 'center', width: 80 },
            { field: 'activated', type: 'boolean', headerName: 'Active', headerAlign: 'center', width: 70 },
            { field: 'printed', type: 'boolean', headerName: 'Printed', headerAlign: 'center', width: 70 },
            { field: 'issued', type: 'boolean', headerName: 'Issued', headerAlign: 'center', width: 70 },

            // { field: 'userId', headerName: 'User', headerAlign: 'center', minWidth: 80, flex: 1 },
            { field: 'userInfo', headerName: 'User', headerAlign: 'center', minWidth: 80, flex: 1 },
            {
                field: 'actions',
                type: 'actions',
                getActions: (params: GridRowParams) => [
                    <GridActionsCellItem icon={<EditIcon />} onClick={() => onDetails(params.row)} label='Details' />,
                ],
            },
        ],
        []
    );


    const onSearchTextRemove = React.useCallback(() => {
        setSearchVal('')
        setDataRequested(false)
    }, [])

    const onSearchTextSubmit = React.useCallback((e) => {
        // setSearchVal(e.target.value)
        setIssuedStatusString('false');
        setIssuedStatus(false)
        setPrintedStatusString('false');
        setPrintedStatus(false);
        setActivatedStatusString('false');
        setActivatedStatus(false);
        setDataRequested(false)
    }, [])

    const searchTextChange = React.useCallback((e) => {
        setSearchVal(e.target.value)
        if (e.target.value === '') {
            setDataRequested(false)
        }
    }, [])

    const onSubmit = React.useCallback((e) => {

        e.preventDefault();
        setDataRequested(false)

    }, [])

    const handleLangChange = React.useCallback((event) => {

        if (event.target.id === 'vipStatus') {
            setVipStatus(event.target.checked);
            if (event.target.checked === true) {
                setVipStatusString('true');
                setDataRequested(false);
            } else {
                setVipStatusString('false');
                setDataRequested(false);
            }
        }

        if (event.target.id === 'issuedStatus') {
            setIssuedStatus(event.target.checked);
            if (event.target.checked === true) {
                setIssuedStatusString('true');
                setSearchVal('')
                setDataRequested(true);

            } else {
                setIssuedStatusString('false');
                setDataRequested(false);
            }
        }

        if (event.target.id === 'printedStatus') {
            setPrintedStatus(event.target.checked);
            if (event.target.checked === true) {
                setPrintedStatusString('true');
                setSearchVal('')
                setDataRequested(false);
            } else {
                setPrintedStatusString('false');
                setDataRequested(false);
            }
        }

        if (event.target.id === 'activatedStatus') {
            setActivatedStatus(event.target.checked);
            if (event.target.checked === true) {
                setActivatedStatusString('true');
                setSearchVal('')
                setDataRequested(false);
            } else {
                setActivatedStatusString('false');
                setDataRequested(false);
            }
        }
    }, []);

    const onDetails = React.useCallback((card: CardRowDisplayData) => {
        //console.log(card);
        setCardDetailsId(card.cardId);
    }, []);

    // React.useEffect(() => {
    //     mounted.current = true;
    //     if (!dataRequested) {
    //         Api.requestAdmin<CardsApi.ApiCard[]>('cards', 'fetch', {
    //             vipStatus: vipStatusString,
    //             issuedStatus: issuedStatusString,
    //             printedStatus: printedStatusString,
    //             activatedStatus: activatedStatusString,
    //             searchVal: searchVal === '' ? 'empty' : searchVal,
    //         })
    //             .then((cards) => {
    //                 if (mounted.current) {
    //                     //setCards(cards);
    //                     let cardsData: CardRowDisplayData[] = [];
    //                     for (let c of cards) {
    //                         console.log('c', c);
    //                         cardsData.push(new CardRowDisplayData(c));
    //                     }

    //                     setCards(cardsData);
    //                 }
    //             })
    //             .catch(setError);
    //         setDataRequested(true);
    //         return;
    //     }
    //     return () => {
    //         mounted.current = false;
    //     };
    // }, [dataRequested]);


    if (error) {
        return <ErrorMessage error={error} />;
    }

    if (!cards) {
        return <></>;
    }

    return (
        <>
            <Stack direction='column' height='100%' alignItems='center' spacing={2}>
                <Stack direction='row' width='100%' spacing={2} alignItems='center'>

                    <Typography>Total Cards:&nbsp;{cards.length}</Typography>

                    <Button
                        variant='contained'
                        onClick={() => {
                            setPrdouceCards(true);
                        }}
                    >
                        Produce Cards
                    </Button>

                    <Checkbox
                        id='vipStatus'
                        name='vipStatus'
                        onChange={handleLangChange}
                        checked={vipStatus}
                    />
                    <Typography>VIP</Typography>

                    <Checkbox
                        id='issuedStatus'
                        name='issuedStatus'
                        onChange={handleLangChange}
                        checked={issuedStatus}
                    />
                    <Typography>Not Issued</Typography>

                    <Checkbox
                        id='printedStatus'
                        name='printedStatus'
                        onChange={handleLangChange}
                        checked={printedStatus}
                    />
                    <Typography>Not Printed</Typography>

                    <Checkbox
                        id='activatedStatus'
                        name='activatedStatus'
                        onChange={handleLangChange}
                        checked={activatedStatus}
                    />
                    <Typography>Not Activated</Typography>

                    <form onSubmit={onSubmit} style={{ display: 'flex', backgroundColor: '#242c37' }}>

                        <InputBase
                            sx={{ ml: 1, flex: 1, }}
                            placeholder='Search'
                            inputProps={{ 'aria-label': 'search google maps' }}
                            // onChange={(e) => {setSearchVal(e.target.value)}}
                            onChange={searchTextChange}
                            value={searchVal}
                        />
                        <IconButton type='button' sx={{ p: '10px' }} aria-label='search' onClick={onSearchTextRemove}>
                            <BackspaceIcon />
                        </IconButton>
                        <Divider sx={{ height: 28, m: 0.5 }} orientation='vertical' />
                        <Button onClick={onSearchTextSubmit}>
                            <DirectionsIcon />
                        </Button>
                    </form>

                </Stack>

                <DataGridPro
                    sx={{
                        width: '100%',
                        color: theme_.dataGridTextColor
                    }}

                    apiRef={apiRef}
                    hideFooterPagination
                    rowCount={rowCount}
                    sortingMode="server"
                    filterMode="server"
                    rowsLoadingMode="server"
                    onFetchRows={debouncedHandleFetchRows}
                    experimentalFeatures={{
                        lazyLoading: true,
                    }}

                    columns={gridColumns}
                    rows={cards}
                    // autoPageSize={true}
                    // disableSelectionOnClick
                    // disableColumnMenu
                    getRowId={(row) => row.cardId}
                />
            </Stack>

            {cardDetailsId && (
                <CardDetailsModal
                    cardId={cardDetailsId}
                    onDetailsClose={(changed) => {
                        setCardDetailsId(null);
                        if (changed) {
                            setDataRequested(false);
                        }
                    }}
                />
            )}
            {produceCards && (
                <ProduceCardsModal
                    onClose={() => {
                        setPrdouceCards(false);
                        setDataRequested(false);
                    }}
                ></ProduceCardsModal>
            )}
            {issuedCard && (
                <IssuedCard
                    cardId={issuedCard}
                    onClose={() => {
                        setIssuedCard(null);
                        setDataRequested(false);
                    }}
                ></IssuedCard>
            )}
        </>
    );
}

// {
//     field: 'printed', headerName: 'Printed', headerAlign: 'center', width: 70, renderCell: (params) => {
//         return <>
//             {params.row.printed === true && <Typography sx={{ color: 'green' }}>P</Typography>}
//             {params.row.printed === false && <Typography sx={{ color: 'red' }}>P</Typography>}
//         </>;
//     }
// },

// {
//     field: 'issued', headerName: 'Issued', headerAlign: 'center', width: 80, renderCell: (params) => {
//         return <>
//             {params.row.issued === true && <Typography sx={{ color: 'green' }}>I</Typography>}
//             {params.row.issued === false && <Typography sx={{ color: 'red' }}>I</Typography>}
//         </>;
//     }
// },

// {
//     field: 'activated', headerName: 'Activated', headerAlign: 'center', width: 80, renderCell: (params) => {
//         return <>
//             {params.row.activated === true && <Typography sx={{ color: 'green' }}>A</Typography>}
//             {params.row.activated === false && <Typography sx={{ color: 'red' }}>A</Typography>}

//         </>;
//     }
// },

// { field: 'clientEmail', headerName: 'Client Email', headerAlign: 'center', width: 250 },

// {
//     field: 'orderDate', headerName: 'Order Date', type: 'date', width: 300,
//     valueGetter: (cell: GridValueGetterParams<CardsApi.ApiCard>) => JSON.stringify(cell.row.orderDate),
// },

// {
//     field: '', type: 'actions', headerName: 'Actions', width: 100, renderCell: (cell) => {
//         return <>
//             <Button variant='contained' onClick={() => setCardDetailsId(cell.id as string)}>Details</Button>
//         </>;
//     }
// },
